import { Link } from 'react-router-dom';
import { ScrollReveal } from "../../../components/scroll-reveal";
import { DORA_PILLARS } from "../../../data/dora-controls";

export default function DoraFramework() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            International Frameworks / DORA
          </div>

          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Digital Operational Resilience Act
            <br />
            EU Financial Sector Regulation
          </h1>

          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Harmonized ICT risk management for European financial entities — banks, insurers, investment firms, and critical ICT providers.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#dora-pillars"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Download DORA Framework
            </a>
            <a
              href="#timeline"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              View Implementation Timeline
            </a>
            <Link
              to="/frameworks/india/rbi"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl px-5 text-sm font-semibold text-[color:var(--text-link)] transition-colors hover:text-text-primary"
            >
              Back to India →
            </Link>
          </div>

          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { k: "Pillars", v: "5" },
              { k: "Effective", v: "Jan 2025" },
              { k: "Scope", v: "EU Financial" },
            ].map((s) => (
              <div key={s.k} className="glass-card sheen p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">{s.k}</div>
                <div className="mt-2 font-[family:var(--font-space-grotesk)] text-3xl font-semibold text-text-primary">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-secondary py-20" id="dora-pillars">
        <div className="container-ivalue">
          <ScrollReveal>
            <div className="glass-card p-6">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                DORA pillars
              </div>
              <h2 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">
                5 pillars
              </h2>

              <div className="mt-6 grid gap-3 md:grid-cols-2">
                {DORA_PILLARS.map((p) => (
                  <div key={p.pillar} className="rounded-2xl border border-border-subtle bg-white/5 p-5">
                    <div className="text-lg font-semibold text-text-primary">{p.pillar}</div>
                    <div className="mt-2 text-sm leading-relaxed text-text-secondary">{p.description}</div>
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="bg-background-primary py-20" id="timeline">
        <div className="container-ivalue">
          <ScrollReveal>
            <div className="glass-card p-6">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                Implementation timeline
              </div>
              <h2 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">
                Effective January 2025
              </h2>
              <div className="mt-4 text-sm text-text-secondary">
                In Part 5, we can extend this into a full obligations checklist + evidence automation view for EU financial entities.
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}
